Namespace 'CustomerVisualMode.Filters.LastInterval.Converters'

class CustomerVisualMode.Filters.LastInterval.Converters.WeekConverter
  constructor: ->
    @aWeekInSeconds = moment.duration(1, 'weeks').asSeconds()

  toSeconds: (week) ->
    {
      name: @_label(week)
      interval: @_weeksInSeconds(week)
    }

  canConvert: (seconds) ->
    (seconds % @aWeekInSeconds) == 0

  getLabelFromSeconds: (seconds) ->
    weeks = Math.round(moment.duration(seconds, 'seconds').asWeeks())
    @_label(weeks)

  _weeksInSeconds: (week) ->
    moment.duration(week, 'weeks').asSeconds()

  _label: (week) ->
    I18n.t('customer_visual_mode.filters.date.last_interval.week', count: week)
